import { Slider, styled } from '@mui/material';
import { HelixPalette, HelixStyles } from '../../helix';
/**
 * Helix styled Slider.
 */
export const HelixSlider = styled(Slider)(() => ({
    color: HelixPalette.teal30,
    height: 4,
    padding: '15px 0',
    '& .MuiSlider-thumb': {
        height: 12,
        width: 12,
        backgroundColor: HelixPalette.teal80,
        boxShadow: HelixStyles.elevationBASE,
        '&:hover, &.Mui-active': { boxShadow: 'none' },
        '&.Mui-focusVisible': { boxShadow: HelixStyles.focusVisible1 },
    },
    '& .MuiSlider-track': { border: 'none' },
    '& .MuiSlider-rail': {
        opacity: 0.5,
        backgroundColor: HelixPalette.neutral10,
    },
    '& .MuiSlider-mark': {
        backgroundColor: HelixPalette.neutral10,
        height: 12,
        width: 2,
        '&.MuiSlider-markActive': {
            opacity: 1,
            backgroundColor: HelixPalette.teal30,
        },
    },
    '& .MuiSlider-markLabel': Object.assign({}, HelixStyles.style_07),
    '&.Mui-disabled': {
        '.MuiSlider-track': { backgroundColor: HelixPalette.neutral20 },
        '.MuiSlider-thumb': { backgroundColor: HelixPalette.neutral20 },
        '.MuiSlider-markActive': { backgroundColor: HelixPalette.neutral20 },
    },
    '&[data-mark-lines=false]': {
        '.MuiSlider-mark': { display: 'none' },
    },
    '&[data-mark-labels=false]': {
        '.MuiSlider-markLabel': { display: 'none' },
    },
}));
